module.exports = __webpack_public_path__ + "static/img/IMG_20150610_223748.aecfd4d5.jpg";